import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// ui
import { Box, Flex, scrollableContainerCss3px } from '../../ui';
// feature audit2
import * as H from './helpers';
import AuditGroup from './components/audit-group';
import { makeSelectAuditList } from './selectors';
import { setInitialState, getAuditListRequest } from './actions';
import { fieldSetting, renderHeader } from './settings/field-settings';
//////////////////////////////////////////////////

const Audit2 = (props) => {
  const {
    height,
    externalList,
    useExternalList,
    withoutPagination,
    externalListLoading,
    requestOptions = {},
    useFullScreen = false,
    handleToggleExternalList,
    maxHeight = 'calc(100vh - 160px)',
  } = props;

  const dispatch = useDispatch();

  const internalList = useSelector(makeSelectAuditList());

  const auditList = useExternalList ? externalList : internalList;

  const width = G.ifElse(useFullScreen, '100%', H.AUDIT_WIDTH);

  const handleGetAuditList = (requestOptions) => dispatch(getAuditListRequest(requestOptions));

  useEffect(() => {
    if (G.isNilOrEmpty(G.getPropFromObject(GC.FIELD_OBJECT_GUID, requestOptions))) return;

    handleGetAuditList(requestOptions);

    return () => dispatch(setInitialState());
  }, [dispatch, requestOptions]);

  return (
    <Box
      bg='white'
      height={height}
      maxWidth='95vw'
      overflowX='auto'
      data-testid='testid-Audit2'
      css={scrollableContainerCss3px}
    >
      <Box
        data-testid='testid-Audit2-innerWrapper'
        minWidth={useFullScreen ? 700 : 'unset'}
      >
        <Box
          px={15}
          width={width}
          background='#E0E0E0'
          borderBottom={`1px solid ${G.getTheme('colors.white')}`}
        >
          <Flex
            height={32}
            width='calc(100% - 30px)'
          >
            {renderHeader(fieldSetting)}
          </Flex>
        </Box>
        <Box
          width={width}
          overflowY='auto'
          maxHeight={maxHeight}
          css={scrollableContainerCss3px}
        >
          {
            G.isNotNil(auditList) &&
            <AuditGroup
              useExternalList={useExternalList}
              withoutPagination={withoutPagination}
              handleGetAuditList={handleGetAuditList}
              externalListLoading={externalListLoading}
              groupedList={G.groupListByDate(auditList)}
              handleToggleExternalList={handleToggleExternalList}
            />
          }
        </Box>
      </Box>
    </Box>
  );
};

export default Audit2;
